import request from "@/CommonDP/utils/request";
export default {
  queryPrjAllPage(params, pageNo, pageSize) {
    return request.post(`/lc/flow/workbench/queryPrjAllPage?pageSize=${pageSize}&pageNum=${pageNo}`, params);
  },
}